import { gql } from '@apollo/client';
import { SortingDetailDownloadFilterInput } from '../../types/dashboard/DailyHubOperationDetailTypes';

export const GENERATE_SORTING_DETAIL_DOWNLOAD_REPORT = gql`
    mutation GenerateSortingDetailDownloadReport($filter: SortingDetailDownloadFilterInput!, $timezone: String) {
        generateSortingDetailDownloadReport(filter: $filter, timezone: $timezone)
    }
`;

export interface GenerateSortingDetailDownloadReportVariables {
    filter: SortingDetailDownloadFilterInput;
    timezone?: string;
}

export interface GenerateSortingDetailDownloadReportResponse {
    generateSortingDetailDownloadReport: string;
}
